import React from "react";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import DashboardChart from "components/Next/Charts/DashboardChart";

import InfoChartContainer from "containers/Next/Charts/InfoChart";

import NextSearchContainer from "containers/Next/NextSearch";
import NextChartContainer from "components/Next/Charts/NextChart";

import AssignTodoModalContainer from "containers/Market/Jobs/AssignTodoModal";

import { Virtuoso } from "react-virtuoso";

import styles from "./style.module.css";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class Dashboard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      searchOpts: [],
      expandChart: undefined
    };
  }

  render() {
    const { dashboardLayout } = this.props;

    return (
      <div className={styles.dashboard}>
        {dashboardLayout?.value === "TILED"
          ? this.renderTiled()
          : dashboardLayout?.value === "REPORT"
            ? this.renderReport()
            : this.renderInfographic()}
      </div>
    );
  }

  renderTiled() {
    const {
      id,
      originalId,
      allCharts,
      searchCharts,
      isHideLegend,
      dashboardSize,
      isAngleAxis,
      updateDashboardChartOptions,
      dashboardChartOptions,
      updateSearchDashboard,
      updateSearchDashboardSimple,
      quickSearch,
      updateHideLine,
      updateHideLines,
      hideLines,
      isDomainMin,
      dataset
    } = this.props;

    const retCharts = searchCharts !== undefined && searchCharts.length > 0 ? searchCharts : allCharts;
    const hasCharts = retCharts?.[0]?.data && retCharts?.[0]?.data.length > 0;

    return (
      <div className={styles.iDashboard}>
        <AssignTodoModalContainer id={id} />
        <div className={styles.nextSearch}>
          <NextSearchContainer id={id} isOnlySearch isDashboard originalId={originalId} />
        </div>
        {hasCharts !== true ? (
          <div className={styles.loadHolder} style={{ marginTop: "20px" }}>
            <LoadingIndicator style={{ margin: "0px" }} />
          </div>
        ) : (
          <div className={styles.botCharts}>
            {retCharts.map((chart, i) => (
              <div
                className={
                  dashboardSize === undefined || dashboardSize === "MEDIUM"
                    ? styles.dashboardChartMedium
                    : dashboardSize === "SMALL"
                      ? styles.dashboardChartSmall
                      : dashboardSize === "LARGE"
                        ? styles.dashboardChartLarge
                        : styles.dashboardChartSmall
                }
                key={"dChart_" + i}
              >
                <DashboardChart
                  id={id}
                  chart={chart}
                  isHideLegend={isHideLegend}
                  isAngleAxis={isAngleAxis}
                  dashboardChartOptions={dashboardChartOptions}
                  updateDashboardChartOptions={updateDashboardChartOptions}
                  updateHideLine={updateHideLine}
                  updateHideLines={updateHideLines}
                  hideLines={hideLines}
                  updateSearchDashboard={updateSearchDashboard}
                  updateSearchDashboardSimple={updateSearchDashboardSimple}
                  quickSearch={quickSearch}
                  isDomainMin={isDomainMin}
                  dataset={dataset}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  renderExpandModal() {
    const { id } = this.props;
    const { expandChart, expandHighlightProps } = this.state;

    return (
      <Dialog open={expandChart !== undefined} onOpenChange={() => this.setState({ expandChart: undefined })}>
        <DialogContent size="full">
          <DialogHeader>
            <DialogTitle>{expandChart?.narrative?.title}</DialogTitle>
          </DialogHeader>
          <div className={styles.dashboardBenchmarkModalBody}>
            {expandChart && (
              <NextChartContainer
                id={id}
                // TODO: Madness please fix this. To show muscle chart
                node={{
                  chart: {
                    chart: expandChart,
                    fields: expandChart?.fields,
                    narrative: expandChart?.narrative
                  },
                  fields: expandChart?.fields ?? {}
                }}
                chart={{ ...expandChart, chart: expandChart?.chart }}
                hideTitle
                isExpand
                showLeakage={true}
                showTooltip={true}
                highlightProps={expandHighlightProps}
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  renderInfographic() {
    const { id, originalId, searchOpts, ignoreInfoChartField, allCharts } = this.props;

    let baseCharts = [];
    allCharts &&
      allCharts.forEach((chart) => {
        const average = chart?.data.reduce((a, b) => a + b?.["Average " + chart?.title], 0) / chart.data.length;

        chart.data.forEach((cData, i) => {
          baseCharts.push({
            chart: chart,
            slice: cData.name,
            score: chart?.mainChart?.score + Math.abs(cData["Average " + chart?.title] - average)
          });
        });
      });

    const retBestCharts = baseCharts
      .filter((charts) => {
        const dChart = charts?.chart;

        return ignoreInfoChartField?.[dChart.title + ": " + dChart?.data?.[0]?.name] !== true;
      })
      .sort((a, b) => b.score - a.score)
      .filter((charts, i) => charts?.slice !== "{Other}")
      .filter((charts, i) => i < 10);

    const retSearchCharts =
      searchOpts && searchOpts?.length > 0
        ? searchOpts
            .filter((sOpt) => ignoreInfoChartField?.[sOpt?.filterField + ": " + sOpt?.filterValue] !== true)
            .map((sOpt) => {
              const aMain = allCharts.find((ac) => ac.title === sOpt.filterField);
              const aSlice = aMain?.data?.find((da) => da.name === sOpt.filterValue);
              const aAvg =
                aMain?.data !== undefined
                  ? aMain.data.reduce((am, bm) => am + bm["Average " + sOpt.filterField], 0) / aMain.data.length
                  : 0;
              const aScore = aMain?.mainChart?.score + Math.abs(aSlice?.["Average " + sOpt.filterField] - aAvg) / 5;

              return { ...sOpt, score: aScore };
            })
        : [];
    const maxSearch = searchOpts ? searchOpts.reduce((a, b) => (a > b.score ? a : b.score), -99999) : 1;

    const retSearchChartsSorted = (retSearchCharts ?? []).sort((a, b) => {
      return b.score - a.score;
    });

    return (
      <div className={styles.iDashboard}>
        <div className={styles.infoHeader}>
          {this.renderExpandModal()}
          <NextSearchContainer id={id} originalId={originalId} isOnlySearch isOnlyValue />
        </div>
        <div className={styles.infoChartHolder}>
          {retSearchCharts && retSearchCharts.length > 0 ? (
            <Virtuoso
              data={retSearchChartsSorted}
              itemContent={(index) => {
                const sOpt = retSearchChartsSorted[index];

                return (
                  <InfoChartContainer
                    key={"infochart_" + index}
                    id={id}
                    rankIndex={index}
                    field={sOpt.filterField}
                    value={sOpt.filterValue}
                    scoreRatio={sOpt?.score / maxSearch}
                    onExpand={(expandChart, expandHighlightProps) =>
                      this.setState({
                        expandChart: expandChart,
                        expandHighlightProps: expandHighlightProps
                      })
                    }
                    barTooltipPosition={
                      index >= (retSearchChartsSorted ?? [])?.length - 2 && index > 0 ? "top" : undefined
                    }
                  />
                );
              }}
            />
          ) : (
            <Virtuoso
              data={retBestCharts}
              itemContent={(index) => {
                const charts = retBestCharts?.[index];
                const dChart = charts?.chart;

                const dataSlice = dChart.data.find((cd) => cd.name === charts?.slice);

                const rValue = dChart?.secondaryCharts?.[0]?.metadata?.properties?.find(
                  (p) => p.column === dChart?.title
                );
                const rBucket =
                  rValue === undefined
                    ? undefined
                    : dChart?.data?.find(
                        (da) =>
                          da.name.indexOf(" to " + rValue.end) !== -1 ||
                          (rValue?.value !== undefined && da.name.indexOf(rValue.value) !== -1)
                      )?.name;

                const rAverage = dChart?.data?.find((da) => da.name === rBucket)?.["Average " + dChart.title];

                return (
                  <InfoChartContainer
                    key={"infochart_" + index}
                    id={id}
                    rankIndex={index}
                    field={dataSlice?.column}
                    value={dataSlice?.name}
                    average={dataSlice?.["Average " + dChart.title]}
                    scoreRatio={charts?.score / retBestCharts?.[0]?.score}
                    onExpand={(expandChart, expandHighlightProps) =>
                      this.setState({
                        expandChart: expandChart,
                        expandHighlightProps: expandHighlightProps
                      })
                    }
                    barTooltipPosition={index >= (retBestCharts ?? [])?.length - 2 && index > 0 ? "top" : undefined}
                  />
                );
              }}
            />
          )}
        </div>
      </div>
    );
  }

  renderExpandDashboardModal() {
    const {
      id,
      isHideLegend,
      isAngleAxis,
      updateDashboardChartOptions,
      dashboardChartOptions,
      updateSearchDashboard,
      updateSearchDashboardSimple,
      quickSearch,
      updateHideLine,
      updateHideLines,
      hideLines,
      isDomainMin,
      dataset
    } = this.props;

    const { reportModal } = this.state;

    const chart = reportModal?.chart;
    const index = reportModal?.index;

    return (
      <Dialog open={reportModal !== undefined} onOpenChange={() => this.setState({ reportModal: undefined })}>
        <DialogContent size="full">
          <DialogHeader>
            <DialogTitle>{chart?.title}</DialogTitle>
          </DialogHeader>
          <div className={styles.dashboardModalBody}>
            {chart && (
              <DashboardChart
                id={id}
                chart={chart}
                isHideLegend={isHideLegend}
                isAngleAxis={isAngleAxis}
                dashboardChartOptions={dashboardChartOptions}
                updateDashboardChartOptions={updateDashboardChartOptions}
                updateHideLine={updateHideLine}
                updateHideLines={updateHideLines}
                hideLines={hideLines}
                updateSearchDashboard={updateSearchDashboard}
                updateSearchDashboardSimple={updateSearchDashboardSimple}
                quickSearch={quickSearch}
                isDomainMin={isDomainMin}
                isInfographic={true}
                uChartStr={chart?.title + "_" + index + "_left"}
                dataset={dataset}
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  renderReport() {
    const {
      id,
      allCharts,
      searchCharts,
      isHideLegend,
      isAngleAxis,
      updateDashboardChartOptions,
      dashboardChartOptions,
      updateSearchDashboard,
      updateSearchDashboardSimple,
      quickSearch,
      updateHideLine,
      updateHideLines,
      hideLines,
      isDomainMin,
      originalId,
      dataset
    } = this.props;

    const retCharts = searchCharts !== undefined && searchCharts.length > 0 ? searchCharts : allCharts;
    const hasCharts = retCharts?.[0]?.data && retCharts?.[0]?.data.length > 0;

    return (
      <div className={styles.iDashboard}>
        <AssignTodoModalContainer id={id} />
        {hasCharts === true && this.renderExpandDashboardModal()}
        <div className={styles.nextSearch}>
          <NextSearchContainer id={id} isOnlySearch isDashboard originalId={originalId} />
        </div>
        {hasCharts !== true ? (
          <div className={styles.loadHolder} style={{ marginTop: "20px" }}>
            <LoadingIndicator style={{ margin: "0px" }} />
          </div>
        ) : (
          <div className={styles.botCharts}>
            <div className={styles.botLeft}>
              {retCharts.map((chart, i) => (
                <div className={styles.dashboardChartInfographic} key={"dash-" + i} style={{ width: "unset" }}>
                  <DashboardChart
                    id={id}
                    chart={chart}
                    isHideLegend={isHideLegend}
                    isAngleAxis={isAngleAxis}
                    dashboardChartOptions={dashboardChartOptions}
                    updateDashboardChartOptions={updateDashboardChartOptions}
                    updateHideLine={updateHideLine}
                    updateHideLines={updateHideLines}
                    hideLines={hideLines}
                    updateSearchDashboard={updateSearchDashboard}
                    updateSearchDashboardSimple={updateSearchDashboardSimple}
                    quickSearch={quickSearch}
                    isDomainMin={isDomainMin}
                    isInfographic={true}
                    uChartStr={chart?.title + "_" + i + "_left"}
                    dataset={dataset}
                    openModal={() => {
                      this.setState({
                        reportModal: { chart: chart, index: i }
                      });
                    }}
                  />
                </div>
              ))}
            </div>
            <div className={styles.botRight}>
              {[...retCharts]
                .sort((a, b) => a?.detailChartRank - b?.detailChartRank)
                .map((chart, i) => (
                  <div className={styles.infoChartRight} key={"rdash-" + i}>
                    <DashboardChart
                      id={id}
                      chart={chart}
                      isHideLegend={isHideLegend}
                      isAngleAxis={isAngleAxis}
                      dashboardChartOptions={dashboardChartOptions}
                      updateDashboardChartOptions={updateDashboardChartOptions}
                      updateHideLine={updateHideLine}
                      updateHideLines={updateHideLines}
                      hideLines={hideLines}
                      updateSearchDashboard={updateSearchDashboard}
                      updateSearchDashboardSimple={updateSearchDashboardSimple}
                      quickSearch={quickSearch}
                      isDomainMin={isDomainMin}
                      isInfographic={true}
                      hideSecondary={true}
                      isRight
                      uChartStr={chart?.title + "_" + i + "_right"}
                      dataset={dataset}
                    />
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}
